// Curated category taxonomy used by the Team Coaching surface (filter
// chips on /content/team and the multi-select picker in the admin Edit
// Content modal). Mirrors the `categories text[]` column on drills —
// values must stay in sync with the data already tagged.
//
// Kebab-case ids land in the database. Labels are display-only.
//
// Backed by supabase/migrations/2026-04-29_drills_categories.sql.

export const TEAM_CATEGORIES = [
  { id: "snapshot-games",      label: "Snapshot Games" },
  { id: "trigger-development", label: "Trigger Development" },
  { id: "transition",          label: "Transition" },
  { id: "defense",             label: "Defense" },
  { id: "half-court-offense",  label: "Half-Court Offense" },
  { id: "scrimmage",           label: "Scrimmage" },
  { id: "spacing",             label: "Spacing" },
];

export const TEAM_CATEGORY_IDS = TEAM_CATEGORIES.map(c => c.id);

// Legacy singular `category` values (drills.category text) that should
// cross-pollinate onto the Team Coaching page. The team surface was
// originally wired to surface tactical PD drills by this field; the newer
// `categories[]` multi-select taxonomy is not yet backfilled, so we keep
// matching on the original field too. Kept here so the rule is discoverable.
export const TEAM_PD_CATEGORY_NAMES = ["Tactical & Passing", "Defense"];

export const TEAM_CATEGORY_LABEL = Object.fromEntries(
  TEAM_CATEGORIES.map(c => [c.id, c.label])
);

// Orthogonal format axis. Every drill is either an on-air technical
// rep (no live defender) or a small-sided game (live constraint-led
// format with opposition). Stored as `drills.format` text — values
// must stay in sync with the SQL check constraint in
// supabase/migrations/2026-04-29_drills_format.sql.
export const DRILL_FORMATS = [
  { id: "on-air", label: "On-Air Drill" },
  { id: "ssg",    label: "Small-Sided Game" },
];

export const DRILL_FORMAT_IDS = DRILL_FORMATS.map(f => f.id);

export const DRILL_FORMAT_LABEL = Object.fromEntries(
  DRILL_FORMATS.map(f => [f.id, f.label])
);
